module.exports = __webpack_public_path__ + "static/media/51_B.d1dc9454.png";